import {
    MonUIRouterTransitionService,
} from '@monsido/services/ui-router-transition-service/ui-router-transition-service';
import { StateService, Transition } from '@uirouter/core';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';

type ActiveFeatureStateResolverOptions = {
    token: string;
    features?: string[];
    pureFeatures?: string[];
    blockFeatures?: string[];
    /**
     * Optional state to redirect to if the active feature check fails.
     * Defaulted to 'base.customer.domain.dashboard'.
     */
    onInvalidRedirectToState?: string;
};

export class UiRouterResolverFactory {
    static createActiveFeatureStateResolver (options: ActiveFeatureStateResolverOptions) {
        return [
            {
                token: options.token,
                deps: [
                    StateService,
                    ActiveFeatureService,
                    MonUIRouterTransitionService,
                    Transition,
                ],
                resolveFn: (
                    $state: StateService,
                    ng2ActiveFeatureService: ActiveFeatureService,
                    ng2MonUIRouterTransitionService: MonUIRouterTransitionService,
                    transition: Transition,
                ) => {
                    let isValid = true;
                    const { features, pureFeatures, blockFeatures, onInvalidRedirectToState } = options;

                    if (features) {
                        for (const feature of features) {
                            if (!ng2ActiveFeatureService.isFeatureActive(feature)) {
                                isValid = false;
                                break;
                            }
                        }
                    }

                    if (pureFeatures) {
                        for (const feature of pureFeatures) {
                            if (!ng2ActiveFeatureService.isFeatureActivePure(feature)) {
                                isValid = false;
                                break;
                            }
                        }
                    }

                    if (blockFeatures) {
                        for (const feature of blockFeatures) {
                            if (ng2ActiveFeatureService.isFeatureActivePure(feature)) {
                                isValid = false;
                                break;
                            }
                        }
                    }

                    if (isValid) {
                        return Promise.resolve(true);
                    }

                    const redirectState = onInvalidRedirectToState || 'base.customer.domain.dashboard';

                    return ng2MonUIRouterTransitionService.onTransitionFinished(() => {
                        $state.go(redirectState, transition.params());
                    });
                },
            },
        ];

    }
}
